import axios from "@/lib/axios";
import AdminService from "@/services/AdminService";

//TODO make dependent on a tab
const apiUrl = process.env.VUE_APP_API_URL_OVERRIDE || window.location.origin;

const state = () => ({
  isAuth: !!localStorage.token,
  userInfo: null,
  isAdmin: false,
  isEditor: false,
});

const getters = {
  getAuthState: state => state.isAuth,
  getUserIsAdmin: state => state.isAdmin,
  getUserIsEditor: state => state.isEditor
};

const mutations = {
  setAuth(state, data = false) {
    state.isAuth = data;
  },
  login(state, data) {
    state.isAuth = true;
    axios.defaults.headers.Authorization = `Bearer ${data}`;
    localStorage.token = data;
  },
  setUserInfo(state, value) {
    state.userInfo = value;
    if (value.authorities) {
      let is_admin = false;
      let is_editor = false;
      value.authorities.forEach(element => {
        if (element.authority === "ROLE_ADMIN") {
          return is_admin = true;
        }
        if (element.authority === "ROLE_EDITOR") {
          return is_editor = true;
        }
      });
      state.isAdmin = is_admin;
      state.isEditor = is_editor;
    }
  }
};

const actions = {
  getToken() {
    localStorage.removeItem("token");
    let redirectUri = new URL(window.location.href);
    redirectUri.searchParams.delete("token");
    window.location = `${apiUrl}/api/autopricing/oauth2/authorize/google?redirect_uri=${redirectUri.href}`;
  },
  setToken({commit}, payload) {
    commit("login", payload);
  },
  getUserInfo({commit}) {
    return AdminService.getUserInfo()
        .then((res) => {
          commit("setUserInfo", res.data);
        });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
